export default __webpack_public_path__ + "static/media/bill.bb0bf991.svg";